import { render, staticRenderFns } from "./createNew.vue?vue&type=template&id=375a423e&scoped=true"
import script from "./createNew.vue?vue&type=script&lang=js"
export * from "./createNew.vue?vue&type=script&lang=js"
import style0 from "./createNew.vue?vue&type=style&index=0&id=375a423e&prod&lang=css"
import style1 from "./createNew.vue?vue&type=style&index=1&id=375a423e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375a423e",
  null
  
)

export default component.exports